<template>
  <div id='bd-block-aside'>
    <div class="block-search">
      <el-input style="width: 80%;" size="mini" :placeholder="searchTip" suffix-icon="el-icon-search" v-model="search" @change="handleSearchChange" clearable></el-input>
      <el-button style="float: right;" size="mini" icon="el-icon-refresh" circle @click="refreshData()"></el-button>
    </div>
    <div style="height: calc(100% - 60px); overflow-y: auto;">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="4">
          <template slot="title">
            <div style="margin-left: 20px;">
              {{ collapseBlockTitle }}
            </div>
          </template>
          <li v-for="block in userBlocks.content" :key="block.bid" class="list-item"
            :class="{ ' active': block.bid === userCurrentBlock.bid }"
            @click="selectBlock(block)">
            <div class="list-left">
              <img class="avatar" width="30" height="30" :alt="block.blockedUser.nickname" :src="block.blockedUser.avatar">
            </div>
            <div class="list-right">
              <div class="top">
                <span class="nickname">{{ block.blockedUser.nickname }}</span>
              </div>
              <div class="bottom">
                <span class="content">{{ block.note }}</span>
              </div>
            </div>
          </li>
          <el-skeleton v-if="isLoading" animated/>
          <el-empty v-if="userBlocks.content.length === 0 && !isLoading" description="空"></el-empty>
          <el-pagination
            :page-size="pageCount"
            :pager-count="5"
            @current-change="handlePageChange"
            :page-count="userBlocks.totalPages"
            :total="userBlocks.totalElements"
            :hide-on-single-page="true"
            layout="prev, pager, next">
          </el-pagination>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import bus from "@/util/eventbus"
const constants = require('@/util/constants')

export default {
  name: 'bd-block-aside',
  data () {
    return {
      search: '',
      activeNames: ['4'],
      selectedContacts: [],
      isLoading: true,
      loadingWidget: "",
      currentPage: 1,
      pageCount: 20,
    }
  },
  computed: {
    ...mapGetters([ 'userBlocks', 'userCurrentBlock', 'showAuthority' ]),
    // filterdBlocks () {
    //   return this.userBlocks.content.filter(block => {
    //     return block.blockedUser.nickname.includes(this.search)
    //   })
    // },
    searchTip () {
      return this.$t('search')
    },
    collapseBlockTitle () {
      return this.$t('blockList')// + ' (' + this.userBlocks.content.length + ')'
    }
  },
  methods: {
    ...mapActions([ 'getBlocks', 'searchBlocks', 'updateCurrentBlock' ]),
    //
    handleSearchChange(value) {
      console.log('handleSearchChange:', value)
      this.currentPage = 1
      if (value === '') {
        let payload = { page: this.currentPage - 1, size: this.pageCount };
        this.getBlocks(payload);
        return
      }
      // 搜索
      let payload = { page: this.currentPage - 1, size: this.pageCount, content: value}
      this.searchBlocks(payload)
    },
    refreshData () {
      // 添加分页
      let payload = { page: this.currentPage - 1, size: this.pageCount }
      this.getBlocks(payload)
      // https://element.eleme.cn/#/zh-CN/component/loading
      // this.loadingWidget = this.$loading({
      //   // target: 'bd-message',
      //   lock: false,
      //   fullscreen: false,
      //   text: "Loading",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)",
      // });
    },
    selectBlock (block) {
      this.updateCurrentBlock(block)
    },
    handlePageChange (page) {
      // console.log('handlePageChange:', page)
      this.currentPage = page
      this.refreshData()
    }
  },
  created () {
    // console.log('block aside created')
    this.refreshData()
  },
  mounted () {
    let app = this
    bus.$on(constants.EVENT_BUS_BLOCKED_LOADED, () => {
      app.isLoading = false
      if (app.loadingWidget) {
        app.loadingWidget.close()
      }
    })
  }
}
</script>

<style scoped>
#bd-block-aside {
  width: 100%;
  height: 100%;
  float: left;
}
.block-search {
  padding: 12px 12px 12px 12px;
}
.list-item {
  padding: 5px 5px 5px 5px;
  margin-bottom: 0px;
  border-bottom: 1px solid beige;
  height: 50px;
}
.list-item:hover {
  background-color: rgb(220,220,220)
}
.active {
  background-color:darkkhaki
}
.list-item .avatar {
  border-radius: 2px;
  margin-right: 2px;
}
li {
  list-style: none;
}
.list-left {
  margin-top: 4px;
  margin-left: 2px;
  width: 25px;
  height: 25px;
  float: left;
}
.list-right {
  margin-left: 42px;
}
.list-right .top {
  margin-top: 2px;
  text-align: left;
}
span.nickname {
  display: inline-block;
  vertical-align: top;
  font-size: 14px;
  width: calc(100% - 10px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
span.timestamp {
  float: right;
  color:gray;
  font-size: 12px;
  vertical-align: top;
  width: 68px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.list-right .bottom {
  width: 0%;
  text-align: left;
}
.list-right .bottom-queue {
  width: 90%;
  text-align: left;
}
.list-right .bottom .content{
  font-size: 12px;
  width: 150px;
  height: 100%;
  color: gray;
  overflow: hidden;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.list-right .unreadCount {
    margin-top: 4px;
    float: right;
    font-size: 10px;
    width: 12px;
    height: 12px;
    line-height: 12px;
    text-align: center;
    border-radius:5px;
    color: white;
    background-color: red;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
